// libs
import React, { memo } from 'react';

interface DiscountTagProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function DiscountTag({ width = 64, height = 64 }: DiscountTagProps) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 40 40"
      width={width}
      height={height}
    >
      <g>
        <path
          fill="#FFC1C8"
          d="M3.4,23.9c-1.1-1.2-1-3.1,0.2-4.2l15-13.4c0.5-0.5,1.2-0.8,2-0.8l9.1-0.1c0.8,0,1.5,0.6,1.7,1.3
		c0.1,0.5-0.5,0.9-0.9,0.6l-1.4-1l-7.2,1.1c-0.7,0.1-1.4,0.5-1.8,1L7.4,22.8c-1.1,1.2-1,3.1,0.3,4.2l4.2,3.8
		c0.3,0.2,0.4,0.6,0.2,0.9c-0.2,0.6-1,0.7-1.4,0.3L3.4,23.9z"
        />
        <path
          fill="#535F6B"
          d="M20.4,8.4L7.3,23.6c-0.7,0.8-0.6,2.1,0.2,2.8l7.1,6.1c0.8,0.7,2.1,0.6,2.8-0.2l1.7-2c0.1,0.4,0.2,0.8,0.3,1.2
		L18.1,33c-1.1,1.3-3,1.4-4.2,0.3l-7.1-6.1c-1.3-1.1-1.4-3-0.3-4.2L19.7,7.8c0.5-0.6,1.1-0.9,1.9-1l7-1c1.8-0.2,3.4,1.1,3.4,2.9
		l0.1,7.1c0,0.7-0.3,1.4-0.7,2l-1.8,2.1c-0.4-0.1-0.8-0.1-1.2-0.1l2.3-2.7c0.3-0.4,0.5-0.8,0.5-1.3l-0.1-7.1c0-1.2-1.1-2.1-2.3-2
		l-7,1C21.2,7.8,20.7,8.1,20.4,8.4z"
        />
        <path
          fill="#535F6B"
          d="M20.4,28.8l6.4-7.5c0.3,0,0.7-0.1,1.1-0.1c0.1,0,0.2,0,0.3,0l-7.7,8.9C20.5,29.8,20.4,29.3,20.4,28.8z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#535F6B"
          d="M26.2,14.9c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7S24.7,14.9,26.2,14.9z M26.2,13.9
		c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7C24.4,13.1,25.2,13.9,26.2,13.9z"
        />
        <path
          fill="#535F6B"
          d="M11.5,24.7c-0.2-0.2-0.5-0.2-0.7,0.1c-0.2,0.2-0.2,0.5,0.1,0.7l4.4,3.8c0.2,0.2,0.5,0.2,0.7-0.1
		c0.2-0.2,0.2-0.5-0.1-0.7L11.5,24.7z"
        />
        <path
          fill="#FD7685"
          d="M35.4,28.8c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5C32.1,21.3,35.4,24.7,35.4,28.8z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M30.9,24.9c0.2,0.2,0.3,0.5,0.1,0.7l-5.5,7c-0.2,0.2-0.5,0.3-0.7,0.1c-0.2-0.2-0.3-0.5-0.1-0.7l5.5-7
		C30.4,24.8,30.7,24.8,30.9,24.9z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M24.4,26c0-0.7,0.6-1.3,1.4-1.3c0.7,0,1.3,0.6,1.3,1.4c0,0.7-0.6,1.3-1.4,1.3C24.9,27.4,24.4,26.7,24.4,26z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M29.1,31.7c0-0.7,0.6-1.3,1.4-1.3c0.7,0,1.3,0.6,1.3,1.4c0,0.7-0.6,1.3-1.4,1.3C29.6,33,29.1,32.4,29.1,31.7z"
        />
      </g>
    </svg>
  );
}

export default memo(DiscountTag);
